/* eslint-disable no-console */
/**
 * One-time migration: unregister any existing service workers and clear Cache Storage.
 * Workbox precaching is disabled; do not register a new service worker.
 */
async function clearServiceWorkersAndCaches() {
  if (!('serviceWorker' in navigator)) return

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map((registration) => registration.unregister()))
    if (registrations.length) {
      console.log('Unregistered service worker(s):', registrations.length)
    }
  } catch (error) {
    console.error('Failed to unregister service workers:', error)
  }

  if (!('caches' in window)) return

  try {
    const keys = await caches.keys()
    await Promise.all(keys.map((key) => caches.delete(key)))
    if (keys.length) {
      console.log('Cleared Cache Storage entries:', keys.length)
    }
  } catch (error) {
    console.error('Failed to clear Cache Storage:', error)
  }
}

if (process.env.NODE_ENV === 'production') {
  clearServiceWorkersAndCaches()
}
